import Constants from '@/constants/const';
import { getCookie, setCookie } from '@/utils/cookie';
import { useRouter } from 'next/router';
import usePageMountEffect from './usePageMountEffect';

export default function useSourceOfStudent() {
  const { query } = useRouter();
  const source = (query.source as string) || '';
  const isSourceOfStudent = source === Constants.STUDENT_SOURCE;
  const sessionToken = getCookie(Constants.WEEE_SESSION_TOKEN) || '';

  const checkSourceOfStudent = () => {
    const eduSession = getCookie(Constants.EDU_SESSION) || '';
    // 有source=student参数，或者在同session内
    return isSourceOfStudent || (!!eduSession && eduSession === sessionToken);
  };

  const setEduSession = () => {
    try {
      setCookie(
        Constants.EDU_SESSION,
        sessionToken,
        {},
        {
          maxAge: Constants.EDU_SESSION_MAX_AGE
        }
      );
    } catch (error) {
      console.error('Failed to set EDU_SESSION cookie:', error);
    }
  };

  usePageMountEffect(() => {
    if (isSourceOfStudent) {
      setEduSession();
    }
  }, [isSourceOfStudent]);

  return { checkSourceOfStudent };
}
